import cronstrue from "cronstrue"
import { classNames } from "primereact/utils"
import { InputText } from "primereact/inputtext"
import { DateTime } from "luxon"
import { getFirstRecurringDate } from "./utilsRecurringControllers"

export const groupFilterTemplate = [
  {
    label: "Appointment Type",
    code: "TYPE",
    items: [
      { label: "Intake", value: "Intake" },
      {
        label: "Recovery Planning Session",
        value: "Recovery Planning Session",
      },
      { label: "Brief Check-in", value: "Brief Check-in" },
      {
        label: "Care Coordination Session",
        value: "Care Coordination Session",
      },
      { label: "Group Session", value: "Group Session" },
      { label: "Discharge Session", value: "Discharge Session" },
    ],
  },
  {
    label: "Status",
    code: "STATUS",
    items: [
      { label: "Active", value: "Active" },
      { label: "Cancelled", value: "Cancelled" },
    ],
  },
  {
    label: "Appointment Channel",
    code: "JP",
    items: [
      { label: "In-Person", value: "in-person" },
      { label: "Telephone", value: "telephone" },
      { label: "Video", value: "video" },
      { label: "Text/App Message", value: "text/app message" },
      { label: "Email", value: "email" },
      { label: "Other", value: "other" },
    ],
  },
]

export function formatDate(x) {
  if (!!x.startDateTime && !!x.endDateTime) {
    let startDateKey = getDateKey(x.startDateTime)
    let endDateKey = getDateKey(x.endDateTime)

    if (
      (x.timezone !== "" && x.timezone != null) ||
      (x.timezoneName !== "" && x.timezoneName != null)
    ) {
      // eslint-disable-line eqeqeq
      if (x.startDateTime.includes("T")) {
        x.startDateTime = DateTime.fromISO(getDate(x.startDateTime).toISO(), {
          zone: x.timezone || x.timezoneName,
        }).setZone(DateTime.local().zoneName)
        x.endDateTime = DateTime.fromISO(getDate(x.endDateTime).toISO(), {
          zone: x.timezone || x.timezoneName,
        }).setZone(DateTime.local().zoneName)
      } else {
        x.startDateTime = DateTime.fromFormat(x.startDateTime, startDateKey, {
          zone: x.timezone || x.timezoneName,
        }).setZone(DateTime.local().zoneName)
        x.endDateTime = DateTime.fromFormat(x.endDateTime, endDateKey, {
          zone: x.timezone || x.timezoneName,
        }).setZone(DateTime.local().zoneName)
      }
      x.scheduledTime =
        x.startDateTime.toFormat("hh:mm a") +
        "-" +
        x.endDateTime.toFormat("hh:mm a")

      x.startDateTime = x.startDateTime.toISO()
      x.endDateTime = x.endDateTime.toISO()
    } else {
      x.scheduledTime =
        DateTime.fromFormat(x.startDateTime, "MM/dd/yyyy hh:mm a ZZ").toFormat(
          "hh:mm a"
        ) +
        "-" +
        DateTime.fromFormat(x.endDateTime, "MM/dd/yyyy hh:mm a ZZ").toFormat(
          "hh:mm a"
        )
    }
  }

  return x
}

export const timezones = [
  { name: "Eastern Standard Time", code: "America/New_York" },
  { name: "Pacific Standard Time", code: "America/Los_Angeles" },
  { name: "Mountain Standard Time", code: "America/Phoenix" },
  { name: "Mountain Daylight Savings Time", code: "America/Denver" },
  { name: "Central Standard Time", code: "America/Chicago" },
  { name: "Hawaii/Aleutian Standard Time", code: "Pacific/Honolulu" },
  { name: "Alaskan Standard Time", code: "America/Anchorage" },
]

export const mainViews = [
  { name: "My Calendar", code: 0 },
  { name: "Organizational Calendar", code: 1 },
  { name: "Staff Calendars", code: 2 },
]

export const services = [
  "Intake",
  "Recovery Planning Session",
  "Brief Check-in",
  "Care Coordination Session",
  "Group Session",
  "Discharge Session",
]

export const recurringServices = [
  //ask about this for ap-338
  "Recovery Planning Session",
  "Brief Check-in",
  "Care Coordination Session",
  "Group Session",
]

export const durations = [
  { code: "15m", name: "15 minutes", mins: "15" },
  { code: "30m", name: "30 minutes", mins: "30" },
  { code: "45m", name: "45 minutes", mins: "45" },
  { code: "60m", name: "60 minutes", mins: "60" },
  { code: "90m", name: "90 minutes", mins: "90" },
  { code: "2h", name: "2 hours", mins: "120" },
  { code: "3h", name: "3 hours", mins: "180" },
  { code: "4h", name: "4 hours", mins: "240" },
  { code: "5h", name: "5 hours", mins: "300" },
  { code: "6h", name: "6 hours", mins: "360" },
  { code: "7h", name: "7 hours", mins: "420" },
  { code: "8h", name: "8 hours", mins: "480" },
]

export const engagementChannels = [
  "in-person",
  "telephone",
  "video",
  "text/app message",
  "email",
  "other",
]

export const orgCalListViewOptions = [
  "Available Appointments",
  "Declined Appointments",
  "Claimed Appointments",
  "Unclaimed Appointments",
]
export const staffCalListViewOptions = [
  "Pending Appointments",
  "Declined Appointments",
  "Past Appointments",
  "Upcoming Appointments",
]

export const customStyles = {
  content: {
    width: "600px",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },

  inputField: {
    color: "#757575",
    fontFamily: "Lato,sans-serif",
    fontWeight: "700",
    fontSize: "16px",
    width: "45%",
  },
  inputStyle: { marginBottom: "10px", marginTop: "5px", width: "100%" },
}

export const isFormFieldValid = (activeAppointment, name) =>
  activeAppointment.errors[name]

export const formatOrgCalDate = (rowData) => {
  let date = undefined
  if (rowData.startDateTime.includes("T"))
    date = getDate(rowData.startDateTime).toLocal().toFormat("MM/dd/yyyy")
  else {
    date = DateTime.fromFormat(
      rowData.startDateTime,
      getDateKey(rowData.startDateTime)
    )
      .toLocal()
      .toFormat("MM/dd/yyyy")
  }

  return date
}

export const formatDateTimeActual = (rowData) => {
  let date = undefined

  if (rowData.startDateTimeActual) {
    date = DateTime.fromJSDate(rowData.startDateTimeActual)
      .toLocal()
      .toFormat("MM/dd/yyyy")
  }

  return date
}

//Convert JSDate to Luxon and set the timezone to the specified zone.
export const getDateTimezone = (jsDate, timeZoneName) => {
  return DateTime.fromFormat(
    DateTime.fromMillis(jsDate.getTime()).toFormat("MM/dd/yyyy hh:mm a") +
    " " +
    DateTime.now().setZone(timeZoneName).toFormat("ZZ"),
    "MM/dd/yyyy hh:mm a ZZ",
    { zone: timeZoneName }
  )
}

export const formatAvailDate = (obj) => {
  return obj.isRecurring
    ? DateTime.fromISO(getDate(obj.recurringStartDate).toISO(), {
      zone: obj.timezone,
    }).toFormat("MM/dd/yyyy") +
    " - " +
    DateTime.fromISO(getDate(obj.recurringEndDate).toISO(), {
      zone: obj.timezone,
    }).toFormat("MM/dd/yyyy")
    : DateTime.fromISO(getDate(obj.individualStartDate).toISO(), {
      zone: obj.timezone,
    }).toFormat("MM/dd/yyyy") +
    " - " +
    DateTime.fromISO(getDate(obj.individualEndDate).toISO(), {
      zone: obj.timezone,
    }).toFormat("MM/dd/yyyy")
}
export const formatAvailTime = (obj) => {
  //bookmark for weird db value format mismatch
  return obj.isRecurring
    ? obj.recurringStartTime + " - " + obj.recurringEndTime
    : DateTime.fromISO(getDate(obj.individualStartDate).toISO(), {
      zone: obj.timezone,
    }).toFormat("hh:mm a") +
    " - " +
    DateTime.fromISO(getDate(obj.individualEndDate).toISO(), {
      zone: obj.timezone,
    }).toFormat("hh:mm a")
}

export const formatAvailTimezone = (obj) => {
  let tz = timezones.find((x) => x.code === obj.timezone) || { name: "" }
  return tz.name
}

export const formatRecurringRules = (obj) => {
  return obj.cron ? cronstrue.toString(obj.cron) : "N/A"
}

//convert a datestring into a Luxon DateTime object
export function getDate(dateString, luxonFormat) {
  const dateKey = getDateKey(dateString, luxonFormat)

  if (!!dateKey) {
    return DateTime.fromFormat(dateString, dateKey)
  } else {
    return DateTime.fromISO(dateString, { setZone: true })
  }
}

//Convert a datestring into a luxon DateTime object and force the timezone to the specified zone, keeping the time as is
export function getDateOverrideZone(dateString, luxonFormat, timezone) {
  let date = getDate(dateString, luxonFormat)

  return date.setZone(timezone, {
    keepLocalTime: true,
  })
}

export function getDateKey(startDateTime, luxonFormat) {
  let dateKey = ""

  if (!!startDateTime) {
    if (startDateTime.includes("/")) {
      dateKey = "MM/dd/yyyy hh:mm a"
    } else if (!startDateTime.includes("T")) {
      dateKey = "yyyy-MM-dd hh:mm a"
    }

    if (startDateTime.split(":").length === 4) {
      dateKey = dateKey.replace("hh:mm", "hh:mm:ss")
    }

    if (startDateTime.includes(" -") || startDateTime.includes(" +")) {
      dateKey += " ZZ"
    }

    if (luxonFormat) {
      dateKey = dateKey.replace("DD", "dd")
      dateKey = dateKey.replace("yyyy", "yyyy")
      dateKey = dateKey.replace("A", "a")
    }
  }

  return dateKey
}

export function reformatAvailability(
  activeAvailability,
  user,
  data,
  forModal,
  isEditing,
  isRecurringController,
  editingRulesForController,
  cron,
  toast
) {
  let payload

  if (forModal) {
    const parseDateWithoutZone = (isoString) => {
      if (!isoString || isoString.startsWith("0001-01-01")) return new Date()

      // Manually remove the timezone offset from the string.
      const datePart = isoString.substring(0, 19)

      // Now, parse the string. Since there is no offset, Luxon will
      // create the DateTime in the system's local zone by default,
      // preserving the "wall time"
      const dt = DateTime.fromISO(datePart)

      if (!dt.isValid) return new Date()
      return dt.toJSDate()
    }

    payload = {
      id: data.id,
      availableDate: data.isRecurring
        ? new Date()
        : parseDateWithoutZone(data.individualStartDate),
      endTime: data.isRecurring
        ? DateTime.fromFormat(data.recurringEndTime, "hh:mm a").toJSDate()
        : parseDateWithoutZone(data.individualEndDate),
      startTime: data.isRecurring
        ? DateTime.fromFormat(data.recurringStartTime, "hh:mm a").toJSDate()
        : parseDateWithoutZone(data.individualStartDate),
      endDate: parseDateWithoutZone(data.recurringEndDate),
      startDate: parseDateWithoutZone(data.recurringStartDate),
      appointmentBuffer: durations.find(
        (x) => x.mins === data.appointmentBuffer.toString()
      ),
      isRecurring: data.isRecurring,
      cron: data.cron,
      cronDescription: data.isRecurring ? cronstrue.toString(data.cron) : "",
      timezone: timezones.find((x) => x.code === data.timezone) || { name: "" },
    }
  } else {
    let startDate =
      DateTime.fromJSDate(activeAvailability.values.availableDate).toFormat(
        "MM/dd/yyyy"
      ) +
      " " +
      DateTime.fromJSDate(activeAvailability.values.startTime).toFormat(
        "hh:mm a"
      )
    let endDate =
      DateTime.fromJSDate(activeAvailability.values.availableDate).toFormat(
        "MM/dd/yyyy"
      ) +
      " " +
      DateTime.fromJSDate(activeAvailability.values.endTime).toFormat("hh:mm a")

    payload = {
      id: activeAvailability.values.id,
      startTime: startDate,
      endTime: endDate,
      availabilityCron: cron,
      availabilityDuration:
        DateTime.fromFormat(endDate, "MM/dd/yyyy hh:mm a").diff(
          DateTime.fromFormat(startDate, "MM/dd/yyyy hh:mm a"),
          "minutes"
        ).values.minutes || 0,
      timezone: activeAvailability.values.timezone.code,
      appointmentBuffer: parseInt(
        activeAvailability.values.appointmentBuffer.code
      ),
      isRecurring: activeAvailability.values.isRecurring,
      recurringStartDate: DateTime.fromJSDate(activeAvailability.values.startDate).toFormat("MM/dd/yyyy"),
      recurringEndDate: DateTime.fromJSDate(activeAvailability.values.endDate).toFormat("MM/dd/yyyy"),
      recurringStartTime: DateTime.fromJSDate(activeAvailability.values.startTime).toFormat("hh:mm a"),
      recurringEndTime: DateTime.fromJSDate(activeAvailability.values.endTime).toFormat("hh:mm a"),
      peerEmail: user.staff_email_address,
      peerName: user.staff_name_first + " " + user.staff_name_last,
      peerId: user.staff_alias,
      soarId: user.staff_id,
    }
  }
  return payload
}

export function reformatAppointment(
  activeAppointment,
  user,
  data,
  forModal,
  isEditing,
  isRecurringController,
  editingRulesForController,
  isOrgAppt,
  cron,
  toast,
  cronPeriod
) {
  if (forModal) {
    let duration = data.duration
    let tempStartDate, tempEndDate

    if (data.startDateTime.includes("T")) {
      tempStartDate = DateTime.fromISO(getDate(data.startDateTime).toISO(), {
        zone: data.timezoneName || data.timezone,
      })
      tempEndDate = DateTime.fromISO(getDate(data.endDateTime).toISO(), {
        zone: data.timezoneName || data.timezone,
      })
    } else {
      tempStartDate = DateTime.fromFormat(
        data.startDateTime,
        getDateKey(data.startDateTime),
        {
          zone: data.timezoneName || data.timezone,
        }
      )
      tempEndDate = DateTime.fromFormat(
        data.endDateTime,
        getDateKey(data.endDateTime),
        {
          zone: data.timezoneName || data.timezone,
        }
      )
    }
    if (!data.isRecurringController) {
      duration = tempEndDate.diff(tempStartDate, "minutes").values.minutes
    } else {
      duration = data.duration
    }

    let tz = data.timezoneName || data.timezone
    let tzProfile = timezones.find((x) => x.code === tz) || { name: "" }

    let serviceName =
      data.serviceName ||
      data.engagementType ||
      data.recurringController.serviceName
    duration = durations
      .map((x) => parseInt(x.mins))
      .reduce(function (prev, curr) {
        return Math.abs(curr - duration) < Math.abs(prev - duration)
          ? curr
          : prev
      })
    const newData = {
      id: data.id,
      serviceName: serviceName,
      duration: durations.find((x) => x.mins === duration.toString()),
      engagementChannel: data.recurringController
        ? data.recurringController.engagementChannel
        : data.metadata
          ? data.metadata.engagementChannel
          : data.engagementChannel,
      location:
        data.recurringController && isRecurringController
          ? data.recurringController.location
          : data.metadata
            ? data.metadata.location
            : data.location,
      timezone: { code: tz, name: tzProfile.name },
      isRecurringController: isRecurringController,
      startDate:
        data.recurringController && isRecurringController
          ? DateTime.fromISO(
            getDate(data.recurringController.startDate).toISO(),
            {
              zone: data.timezoneName || data.timezone,
            }
          ).toJSDate()
          : tempStartDate.toJSDate(),
      endDate: isRecurringController
        ? data.recurringController
          ? DateTime.fromISO(
            getDate(data.recurringController.endDate).toISO(),
            {
              zone: data.timezoneName || data.timezone,
            }
          ).toJSDate()
          : DateTime.fromISO(getDate(data.endDate).toISO(), {
            zone: data.timezoneName || data.timezone,
          }).toJSDate()
        : tempEndDate.toJSDate(),
      startTime:
        (data.recurringController && isRecurringController) ||
          data.isRecurringController
          ? getDateOverrideZone(
            data.startDateTime,
            undefined,
            data.timezoneName || data.timezone
          ).toJSDate()
          : tempStartDate.toJSDate(),
      cron: cron,
      participant: data.participant,
      cronDescription:
        data.recurringController && isRecurringController
          ? data.recurringController.cronDescription
          : data.newFreq,
      cronDescriptionActual:
        data.recurringController && isRecurringController
          ? data.recurringController.cronDescriptionActual
          : data.newFreq,
      sendEmailNotifications: data.metadata
        ? data.metadata.sendEmailNotifications
        : data.sendEmailNotifications,
      sendSMSNotifications: data.metadata
        ? data.metadata.sendSMSNotifications
        : data.sendSMSNotifications,
    }

    return newData
  } else {
    if (activeAppointment.values.participant === undefined) {
      toast.current.show({
        severity: "warn",
        detail: "You must select a valid participant.",
        life: 3000,
      })
      return
    } else if (activeAppointment.values.serviceName == null) {
      toast.current.show({
        severity: "warn",
        detail: "You must select a valid appointment type.",
        life: 3000,
      })
      return
    } else if (activeAppointment.values.duration.code === "") {
      toast.current.show({
        severity: "warn",
        detail: "You must select a valid duration type",
        life: 3000,
      })
      return
    }
    let durationType =
      activeAppointment.values.duration?.code[
      activeAppointment.values.duration?.code.length - 1
      ]
    let duration = parseInt(activeAppointment.values.duration?.code)
    let momentsType
    let startDate = activeAppointment.values.startDate,
      startTime = activeAppointment.values.startTime

    if (durationType === "h") {
      momentsType = "hours"
    } else {
      momentsType = "minutes"
    }
    let caseUserDetails = {
      firstName: activeAppointment.values.participant.firstName,
      lastName: activeAppointment.values.participant.lastName,
      caseId: activeAppointment.values.participant.code,
      casePhone: activeAppointment.values.participant.phone,
      email: activeAppointment.values.participant.email,
      alias: {
        orgAlias: user.organization_id,
        staffAlias: user.staff_id,
        participantAlias: activeAppointment.values.participant.alias,
      },
    }

    let apptMeta = {
      engagementChannel: activeAppointment.values.engagementChannel,
      location: activeAppointment.values.location,
      peerId: user.staff_alias,
      caseId: activeAppointment.values.participant.code,
      OrgId: user.organization_alias,
      isRecurring: activeAppointment.values.isRecurringController,
      isfromSoar: true,
      cron: cron,
      sendEmailNotifications: activeAppointment.values.sendEmailNotifications,
      sendSMSNotifications: activeAppointment.values.sendSMSNotifications,
      recurringStartDate: activeAppointment.values.startDate
        ? DateTime.fromJSDate(activeAppointment.values.startDate).toISO()
        : undefined,
      recurringEndDate: activeAppointment.values.endDate
        ? DateTime.fromJSDate(activeAppointment.values.endDate).toISO()
        : undefined,
      serviceName: activeAppointment.values.serviceName,
      resourceName: user.staff_name_first + " " + user.staff_name_last,
      selectedPeriod: cronPeriod,
    }

    // if (apptMeta.cron != null)
    //   apptMeta.cron = apptMeta.cron.slice(0, apptMeta.cron.length - 2)

    if (apptMeta.isRecurring) {
      if (
        apptMeta.recurringEndDate === undefined ||
        DateTime.fromJSDate(apptMeta.recurringEndDate) <
        DateTime.fromJSDate(apptMeta.recurringStartDate)
      ) {
        toast.current.show({
          severity: "warn",
          detail: "You must select a valid end date for the recurring rules.",
          life: 3000,
        })
        return
      }

      startDate = getFirstRecurringDate(
        cron,
        startDate,
        DateTime.fromJSDate(activeAppointment.values.startDate)
      )
    }

    const selectedStartDate = DateTime.fromJSDate(startDate)
    const selectedStartTime = DateTime.fromJSDate(startTime).setZone(
      activeAppointment.values.timezone.code
    )

    let startDateTime = DateTime.now()
      .set({
        day: selectedStartDate.day,
        month: selectedStartDate.month,
        year: selectedStartDate.year,
        hour: selectedStartTime.hour,
        minute: selectedStartTime.minute,
        second: 0,
        millisecond: 0,
      })
      .setZone(activeAppointment.values.timezone.code, { keepLocalTime: true })

    let plusObj = {}
    plusObj[momentsType] = duration

    let endDateTime = startDateTime.plus(plusObj)
    /*       DateTime.fromJSDate(startDate).toFormat("MM/dd/yyyy") +
      " " +
      DateTime.fromJSDate(startTime).plus(plusObj).toFormat("hh:mm a") +
      " " +
      activeAppointment.values.timezone.code
 */
    if (startDateTime < DateTime.local()) {
      toast.current.show({
        severity: "warn",
        detail: "You cannot schedule an event in the past.",
        life: 3000,
      })
      return
    }

    if (startDateTime.day !== endDateTime.day) {
      toast.current.show({
        severity: "warn",
        detail:
          "Appointments may not span two different calendar days. Please change the duration of your appointment",
        life: 3000,
      })

      return
    }

    let appointmentDetails = {
      orgId: user.organization_alias,
      participantEmail: activeAppointment.values.participant.email,
      participantName: activeAppointment.values.participant.name,
      participantPhone: activeAppointment.values.participant.phone,
      bookedBy: user.staff_email_address,
      startDateTime: startDateTime.toISO(),
      endDateTime: endDateTime.toISO(),
      serviceName: activeAppointment.values.serviceName,
      staffId: user.staff_alias,
      timezoneName: activeAppointment.values.timezone.code,
      metadata: apptMeta,
    }

    let payload

    if (isEditing && !isOrgAppt) {
      payload = {
        serviceName: activeAppointment.values.serviceName,
        startDateTime: startDateTime.toISO(),
        endDateTime: endDateTime.toISO(),
        timezoneName: activeAppointment.values.timezone.code,
        changingRules: editingRulesForController,
        cron: cron,
        editingRecurringController: !isNaN(+activeAppointment.values.id),
        metadata: apptMeta,
        recurringDuration: parseInt(activeAppointment.values.duration.mins),
        alias: {
          orgAlias: user.organization_id,
          staffAlias: user.staff_id,
          participantAlias: activeAppointment.values.participant.alias,
        },
      }

      if (
        typeof activeAppointment.values.id === "string" &&
        activeAppointment.values.id.includes("recurring") &&
        !isRecurringController
      ) {
        payload.appointmentRequest = appointmentDetails
      }
    } else if (isOrgAppt) {
      apptMeta.isUnclaimed = true
      if (apptMeta.isRecurring) {
        let newStartDate = getDate(apptMeta.recurringStartDate)
          .set({
            hour: startDateTime.hour,
            minute: startDateTime.minute,
            second: 0,
            millisecond: 0,
          })
          .setZone(activeAppointment.values.timezone.code, {
            keepLocalTime: true,
          })

        apptMeta.recurringStartDate = newStartDate.toISO()
      }

      appointmentDetails.name = appointmentDetails.participantName
      appointmentDetails.phone = appointmentDetails.participantPhone
      appointmentDetails.email = appointmentDetails.participantEmail
      appointmentDetails.id = activeAppointment.values.id.toString()
      appointmentDetails.isFromRecurring =
        activeAppointment.values.isRecurringController === false &&
        activeAppointment.values.cron != null
      payload = {
        orgAppointmentDetails: appointmentDetails,
        caseUserDetails: caseUserDetails,
      }
    } else {
      payload = {
        appointmentDetails: appointmentDetails,
        caseUserDetails: caseUserDetails,
      }
    }

    return payload
  }
}

export function editChannelSelect(activeAppointment) {
  switch (activeAppointment.values.engagementChannel) {
    case "in-person":
      return (
        <div style={customStyles.inputField}>
          <label htmlFor="location">Address</label>
          <br />
          <InputText
            style={customStyles.inputStyle}
            id="location"
            onChange={activeAppointment.handleChange}
            value={activeAppointment.values.location}
            className={classNames({
              "p-invalid": isFormFieldValid(activeAppointment, "location"),
            })}
          />
        </div>
      )

    case "telephone":
      return (
        <div style={customStyles.inputField}>
          <label htmlFor="location">Phone Number</label>
          <br />
          <InputText
            style={customStyles.inputStyle}
            id="location"
            onChange={activeAppointment.handleChange}
            value={activeAppointment.values.location}
            className={classNames({
              "p-invalid": isFormFieldValid(activeAppointment, "location"),
            })}
          />
        </div>
      )

    case "video":
      return (
        <div style={customStyles.inputField}>
          <label htmlFor="location">URL</label>
          <br />
          <InputText
            style={customStyles.inputStyle}
            id="location"
            onChange={activeAppointment.handleChange}
            value={activeAppointment.values.location}
            className={classNames({
              "p-invalid": isFormFieldValid(activeAppointment, "location"),
            })}
          />
        </div>
      )

    case "email":
      return (
        <div style={customStyles.inputField}>
          <label htmlFor="location">Email</label>
          <br />
          <InputText
            style={customStyles.inputStyle}
            id="location"
            onChange={activeAppointment.handleChange}
            value={activeAppointment.values.location}
            className={classNames({
              "p-invalid": isFormFieldValid(activeAppointment, "location"),
            })}
          />
        </div>
      )

    case "text/app message":
      return (
        <div style={customStyles.inputField}>
          <label htmlFor="location">Phone Number</label>
          <br />
          <InputText
            style={customStyles.inputStyle}
            id="location"
            onChange={activeAppointment.handleChange}
            value={activeAppointment.values.location}
            className={classNames({
              "p-invalid": isFormFieldValid(activeAppointment, "location"),
            })}
          />
        </div>
      )

    case "other":
      return (
        <div style={customStyles.inputField}>
          <label htmlFor="location">Describe Other</label>
          <br />
          <InputText
            style={customStyles.inputStyle}
            id="location"
            onChange={activeAppointment.handleChange}
            value={activeAppointment.values.location}
            className={classNames({
              "p-invalid": isFormFieldValid(activeAppointment, "location"),
            })}
          />
        </div>
      )

    default:
      return <div style={customStyles.inputField}></div>
  }
}

export function extractSoarId(obj) {
  return obj.soarCaseId
    ? obj.soarCaseId
    : obj.recurringController
      ? obj.recurringController.soarCaseId
      : obj.metadata?.soarCaseId
}

export function acceptRequestedSchedule(
  pendingRequest,
  currentUser,
  participants,
  toast
) {
  let participant = participants.find((x) => +x.code === +pendingRequest.caseId)
  //let timezone = $("#create-timezone-select").val();

  let caseUserDetails = {
    firstName: pendingRequest.participantName.split(" ")[0],
    lastName: pendingRequest.participantName.split(" ")[1],
    caseId: pendingRequest.caseId,
    casePhone: pendingRequest.casePhone, //need
    email: pendingRequest.caseEmail, //need
    alias: {
      orgAlias: currentUser.organization_id,
      staffAlias: currentUser.staff_id,
      participantAlias: participant.alias,
    },
  }

  let apptMeta = {
    engagementChannel: pendingRequest.engagementChannel,
    location: "",
    peerId: currentUser.staff_alias,
    caseId: pendingRequest.caseId,
    OrgId: currentUser.organization_alias,
    cron: pendingRequest.cron,
    isRecurring: pendingRequest.isRecurring,
    selectedPeriod: pendingRequest.selectedPeriod,
    sendEmailNotifications: true,
    sendSMSNotifications: true,
    recurringStartDate: pendingRequest.recurringStartDate,
    recurringEndDate: pendingRequest.recurringEndDate,
    serviceName: pendingRequest.engagementType,
    resourceName:
      currentUser.staff_name_first + " " + currentUser.staff_name_last,
    isfromSoar: true,
  }

  //Create normal appointment
  let appointmentDetails = {
    //locationId: locationId,
    participantEmail: pendingRequest.caseEmail, //need
    participantName: pendingRequest.participantName,
    participantPhone: pendingRequest.casePhone, //need
    bookedBy: currentUser.staff_email_address,
    startDateTime: pendingRequest.startDateTime,
    endDateTime: pendingRequest.endDateTime,
    serviceName: pendingRequest.engagementType,
    timezoneName: pendingRequest.timezone,
    orgId: currentUser.organization_alias,
    staffId: currentUser.staff_alias,
    //timezoneName: tzList[$("#create-timezone-select").val()],
    metadata: apptMeta,
  }

  //Update the start and end dates for recurring appointments
  if (apptMeta.isRecurring) {
    const startDate = getDate(pendingRequest.startDateTime)
    const endDate = getDate(pendingRequest.endDateTime)
    const duration = endDate.diff(startDate, "minutes")

    const firstAppointmentDateJs = getFirstRecurringDate(
      apptMeta.cron,
      startDate.toJSDate(),
      getDate(pendingRequest.recurringStartDate)
    )

    const firstAppointmentStartDate = DateTime.fromJSDate(
      firstAppointmentDateJs
    )
    const firstAppointmentEndDate = firstAppointmentStartDate.plus({
      minutes: duration.minutes,
    })

    appointmentDetails.startDateTime = firstAppointmentStartDate.toISO()
    appointmentDetails.endDateTime = firstAppointmentEndDate.toISO()
  }

  let payload = {
    appointmentDetails: appointmentDetails,
    caseUserDetails: caseUserDetails,
  }

  return payload
}

export function getNumberRange(startValue, endValue) {
  return [...Array(endValue - startValue + 1)].map((_, i) => i + 1)
}

export const weekDays = [
  { name: "Monday", value: "MON" },
  { name: "Tuesday", value: "TUE" },
  { name: "Wednesday", value: "WED" },
  { name: "Thursday", value: "THU" },
  { name: "Friday", value: "FRI" },
  { name: "Saturday", value: "SAT" },
  { name: "Sunday", value: "SUN" },
]
